/* LTCG 30 Oct 2026: "Complete your order" cart upsell (snippets/ltcg-cart-complete.liquid).
   Complementary -> related -> manual "cart-add-ons" collection. Real products and prices only, no urgency/badges.
   Re-renders after every cart change (ltcg:cart-total from ltcg-free-shipping.js, and Horizon morphs). Never opens the drawer. */
(() => {
  if (customElements.get('ltcg-cart-complete')) return;
  const W = window;
  const rate = () => parseFloat((W.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
  const cache = new Map();
  const getJSON = (u) => {
    if (!cache.has(u)) cache.set(u, fetch(u, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => (r.ok ? r.json() : {})).catch(() => ({})));
    return cache.get(u);
  };
  const norm = (p, fromCollection) => {
    const vs = (p.variants || []).map((v) => ({ id: v.id, available: v.available !== false, price: fromCollection ? Math.round(parseFloat(v.price) * 100) : v.price }));
    const v = vs.find((x) => x.available);
    let img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (img && typeof img === 'object') img = img.src || '';
    return v && (p.available !== false) ? { id: String(p.id), handle: p.handle, title: p.title, url: p.url || '/products/' + p.handle, img, v } : null;
  };
  class C extends HTMLElement {
    connectedCallback() {
      if (!this._init) {
        this._init = 1;
        this.addEventListener('click', (e) => { const b = e.target.closest('[data-ltcg-cc-add]'); if (b) this.add(b); });
        this._onCart = (e) => { const c = e.detail; if (!c || !c.items) return; const ids = [...new Set(c.items.map((i) => String(i.product_id)))]; this.dataset.inCart = ids.join(','); this.dataset.products = ids.slice(0, 3).join(','); this.dataset.total = c.total_price; };
      }
      document.addEventListener('ltcg:cart-total', this._onCart);
      this._mo = this._mo || new MutationObserver(() => this.schedule());
      this._mo.observe(this, { attributes: true, attributeFilter: ['data-in-cart', 'data-total'], childList: true, subtree: true });
      this._key = null;
      const go = () => this.schedule();
      'requestIdleCallback' in W ? requestIdleCallback(go, { timeout: 2000 }) : setTimeout(go, 600);
    }
    disconnectedCallback() { document.removeEventListener('ltcg:cart-total', this._onCart); this._mo && this._mo.disconnect(); }
    schedule() { clearTimeout(this._t); this._t = setTimeout(() => this.load(), 60); }
    async load() {
      const d = this.dataset;
      const list = this.querySelector('.ltcg-cc__list'); if (!list) return;
      const key = d.inCart + '|' + d.total;
      if (key === this._key && (list.childElementCount || this.hidden)) return;
      if (this._busy) { this._again = 1; return; }
      this._busy = 1;
      let picks = [];
      try {
        const root = (d.root || '/').replace(/\/$/, '');
        const inCart = (d.inCart || '').split(',').filter(Boolean);
        const skip = new Set(inCart);
        // Products already offered by the "Complete your set" block are not offered twice.
        document.querySelectorAll('[data-ltcg-setup] a[href*="/products/"]').forEach((a) => { const h = a.pathname.split('/products/')[1]; if (h) skip.add('h:' + h.split('/')[0]); });
        const goal = Math.ceil((parseInt(d.threshold, 10) * rate()) / 100) * 100;
        const gap = Math.max(goal - (parseInt(d.total, 10) || 0), 0);
        const max = gap + Math.round(parseInt(d.extra || '4000', 10) * rate());
        const ok = (p) => p && !skip.has(p.id) && !skip.has('h:' + p.handle) && p.v.price <= max && !picks.some((x) => x.id === p.id);
        const take = (arr) => { for (const p of arr) { if (picks.length >= 2) break; if (ok(p)) picks.push(p); } };
        const pids = (d.products || '').split(',').filter(Boolean);
        for (const intent of ['complementary', 'related']) {
          for (const pid of pids) {
            if (picks.length >= 2) break;
            const j = await getJSON(`${root}/recommendations/products.json?product_id=${pid}&limit=10&intent=${intent}`);
            take((j.products || []).map((p) => norm(p, false)));
          }
          if (picks.length >= 2) break;
        }
        // Manual fallback collection; its products.json prices are in the shop currency, so only used when they match.
        if (picks.length < 2 && d.collection && d.currency === d.shopCurrency) {
          const j = await getJSON(`${root}/collections/${d.collection}/products.json?limit=30`);
          take((j.products || []).map((p) => norm(p, true)));
        }
      } catch (e) { picks = []; }
      this._mo.disconnect();
      try { this.render(picks); } finally {
        this._key = key; this._busy = 0;
        this._mo.observe(this, { attributes: true, attributeFilter: ['data-in-cart', 'data-total'], childList: true, subtree: true });
        if (this._again) { this._again = 0; this.schedule(); }
      }
    }
    money(c) {
      const d = this.dataset;
      if (W.ltcgMoney && d.currency === d.shopCurrency) return W.ltcgMoney(c, d.moneyFormat);
      try { return new Intl.NumberFormat(d.locale || 'en', { style: 'currency', currency: d.currency || 'EUR' }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); }
    }
    render(picks) {
      const d = this.dataset, list = this.querySelector('.ltcg-cc__list');
      list.textContent = '';
      if (!picks.length) { this.hidden = true; return; }
      for (const p of picks) {
        const li = document.createElement('li'); li.className = 'ltcg-cc__card';
        const a = document.createElement('a'); a.href = p.url; a.className = 'ltcg-cc__img'; a.tabIndex = -1; a.setAttribute('aria-hidden', 'true');
        if (p.img) { const i = new Image(64, 64); i.src = p.img + (p.img.includes('?') ? '&' : '?') + 'width=128'; i.alt = ''; i.loading = 'lazy'; i.decoding = 'async'; a.append(i); }
        const info = document.createElement('div'); info.className = 'ltcg-cc__info';
        const n = document.createElement('a'); n.href = p.url; n.className = 'ltcg-cc__name'; n.textContent = p.title;
        const pr = document.createElement('span'); pr.className = 'ltcg-cc__price'; pr.textContent = this.money(p.v.price);
        const b = document.createElement('button'); b.type = 'button'; b.className = 'ltcg-cc__btn'; b.dataset.ltcgCcAdd = p.v.id;
        b.textContent = d.tAdd; b.setAttribute('aria-label', d.tAdd.replace(/^\+\s*/, '') + ': ' + p.title);
        info.append(n, pr, b); li.append(a, info); list.append(li);
      }
      this.hidden = false;
    }
    async add(b) {
      if (!W.ltcgAddButton) return;
      const ok = await W.ltcgAddButton(b, b.dataset.ltcgCcAdd, this.dataset.tAdded);
      if (ok && /(^|\/)cart\/?$/.test(location.pathname)) location.reload();
    }
  }
  customElements.define('ltcg-cart-complete', C);
})();
